<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import {v_update} from '@/utils/v_update'

export default {
  name: 'App',
  data(){
    return{
      version: '',
    }
  },
  watch:{
    $route() {
      v_update(this)
    },
  },
}
</script>
